/**
 * Placeholder Wikipedia-style lore article until full text is authored.
 * Replace `text` (or the whole module export) when the article is ready.
 *
 * @param {{ title: string, image: string }} params
 */
export function createComingSoonArticle({ title, image }) {
  if (!title) {
    throw new Error('createComingSoonArticle: title is required');
  }

  return {
    title,
    ...(image ? { image } : {}),
    format: 'wiki',
    text: 'Coming soon.',
  };
}

/**
 * Placeholder order lore article keyed by order id.
 * Display title/image are supplied by the lore API from order_translations.
 *
 * @param {{ orderId: number, text?: string }} params
 */
export function createOrderComingSoonArticle({ orderId, text = 'Coming soon.' }) {
  if (orderId == null || orderId === '') {
    throw new Error('createOrderComingSoonArticle: orderId is required');
  }
  const id = Number(orderId);
  if (!Number.isFinite(id)) {
    throw new Error(`createOrderComingSoonArticle: invalid orderId=${orderId}`);
  }
  if (!text) {
    throw new Error(`createOrderComingSoonArticle: text is required for orderId=${id}`);
  }

  return {
    orderId: id,
    format: 'wiki',
    text,
  };
}
